import React from 'react';
import type { SxProps } from '@mui/system';

import Box from '@mui/material/Box';

import Avatar from 'src/components/ui/Avatar';

import type { Medium, User } from 'src/types/__generated__/graphql';
import { styledComponent } from 'src/utils/styled';

const avatarContainer: SxProps = {
    '> *': {
        '&:first-of-type': {
            top: 0,
            left: 0,
        },
        '&:nth-of-type(2)': {
            bottom: 0,
            right: 0,
        },
    },
};

const StyledAvatar = styledComponent(Avatar)`
    margin-left: -1rem;
    border: 0.063rem solid;
    position: absolute;
`;

type UserData = Pick<User, 'id' | 'fullName' | 'initials' | 'image'>;

interface IProps {
    users: Array<UserData | null>;
    numberOfAvatarsToShow?: number;
    marginRight?: string;
    width?: string;
    height?: string;
}

const SuperposedAvatars: React.FC<IProps> = ({
    users,
    numberOfAvatarsToShow = 2,
    marginRight = '0.75rem',
    width = '3rem',
    height = '2.5rem',
}) => {
    const usersToShow = (users.filter(Boolean) as UserData[]).slice(0, numberOfAvatarsToShow);
    return (
        <Box sx={avatarContainer} display="flex" mr={marginRight} height={height} width={width} position="relative">
            {usersToShow.map((user) => (
                <StyledAvatar
                    key={user.id}
                    image={user.image as Medium}
                    alt={user.fullName}
                    fallbackText={user.initials}
                />
            ))}
        </Box>
    );
};

export default SuperposedAvatars;
